import { render, staticRenderFns } from "./FormDialog.vue?vue&type=template&id=37a45b08"
import script from "./FormDialog.vue?vue&type=script&lang=js"
export * from "./FormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports